import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { threshold: Number }

  connect() {
    this.thresholdValue = this.thresholdValue || 100
    this.handleScroll = this.throttle(this.handleScroll.bind(this), 100)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll() // Initial check
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const shouldHide = window.scrollY > this.thresholdValue
    
    if (shouldHide) {
      this.element.style.transform = 'translateY(-100%)'
      this.element.style.opacity = '0'
      this.element.style.pointerEvents = 'none'
    } else {
      this.element.style.transform = 'translateY(0)'
      this.element.style.opacity = '1'
      this.element.style.pointerEvents = 'auto'
    }
  }

  throttle(func, limit) {
    let inThrottle
    return function() {
      const args = arguments
      const context = this
      if (!inThrottle) {
        func.apply(context, args)
        inThrottle = true
        setTimeout(() => (inThrottle = false), limit)
      }
    }
  }
}

